<section class="page-head">
  <div class="container h-100">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1>{{lang.Locations}}
          <span>{{lang.VisitOurSites}}</span>
        </h1>
      </div>
    </div>
  </div>
  <img src="assets/images/locations.jpg" alt="{{lang.Locations}}">
</section>
<div class="sub-nav">
  <ul>
    <li>
      <a [routerLink]="[lang.LocationDetailsUrl]" class="active">{{lang.OurLocation}}</a>
    </li>
    <li>
      <a [routerLink]="[lang.LocationsSearchUrl]">{{lang.LocationSearch}}</a>
    </li>
  </ul>
</div>
<section class="ptb-90" id="locationFinder" #locationFinder>
  <div class="container mw-1600">
    <div class="mb-3 d-flex flex-wrap align-items-center fl-search">
      <label class="form-label">{{lang.FindAlocation}}</label>
      <div><i class="fas fa-search"></i> <input type="text" class="form-control" [(ngModel)]="PostalCode"
          placeholder="{{lang.Placeholder}}" (keydown.enter)="navigateToLocationSearch()"></div>
    </div>
    <div class="location_map clearfix">
      <div id="leaflet-map" class="leaflet-container leaflet-retina leaflet-fade-anim" tabindex="0" style="position: relative;">
        <div class="leaflet-map-pane" style="transform: translate3d(0px, 9px, 0px);">
          <div class="leaflet-tile-pane"></div>
          <div class="leaflet-objects-pane">
            <div class="leaflet-shadow-pane"></div>
            <div class="leaflet-overlay-pane">
              <img alt="Map of Radius locations" class="leaflet-image-layer leaflet-zoom-animated" tyle="opacity: 1; transform: translate3d(-21px, -73px, 0px); width: 1616px; height: 594px;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="legend">
      <ul>
        <li><span class="mr"></span>{{lang.MetalsRecycling}}</li>
        <li><span class="ap"></span>{{lang.AutoParts}}</li>
        <li><span class="css"></span>{{lang.SteelManufacturing}}</li>
        <li><span class="corporate"></span>{{lang.Corporate}}</li>
      </ul>
    </div>
  </div>
</section>
<section class="lb-bg ptb-90" #locationList id="locationList">
  <div class="container location-list {{lang.LocationListClass}}">
    <div class="d-flex flex-wrap align-items-center">
      <h2 class="title-secondary me-auto">{{lang.LocationList}}</h2>
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [ngClass]="{'active':locationToggle.corporateOffice}" id="corporate-offices-tab"  type="button" role="tab" (click)="onLocationClickToggle('corporateOffice')"><i class="fa-solid fa-building"></i> {{lang.CORPORATEOFFICES}}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="metals-recycling-tab" [ngClass]="{'active':locationToggle.metalsRecycling}" (click)="onLocationClickToggle('metalsRecycling')"
            type="button" role="tab" ><i
              class="fa-solid fa-recycle"></i> {{lang.METALSRECYCLING}}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="auto-recycling-tab" [ngClass]="{'active':locationToggle.autoRecycling}" (click)="onLocationClickToggle('autoRecycling')"
            type="button" role="tab"><i
              class="fa-solid fa-car"></i> {{lang.AUTORECYCLING}}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="steel-manufacturing-tab" type="button" role="tab" [ngClass]="{'active':locationToggle.steelManufacturing}" (click)="onLocationClickToggle('steelManufacturing')"><i class="fas fa-object-ungroup"></i> {{lang.SteelManufacturing}}</button>
        </li>
      </ul>
    </div>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade" role="tabpanel" [ngClass]="{'show active':locationToggle.corporateOffice}"
         tabindex="0">
        <ng-template ngFor let-ml let-i="index" [ngForOf]="grpCorp">
          <div class="location_column1">
            <div *ngFor="let drow of ml.cdata">
              <ul>
                <li *ngFor="let lrow of drow.locations" class="icon-inline">
                  <a [routerLink]="[lang.LocationDetailsUrl, lrow.locationID]">
                    <strong>{{drow.corpDiv}}</strong><br />
                    ({{lrow.mapTextLine1}}) <i class="fa-solid fa-arrow-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="tab-pane fade" role="tabpanel" [ngClass]="{'show active':locationToggle.metalsRecycling}"
        tabindex="0">
        <ng-template ngFor let-ml let-i="index" [ngForOf]="grpMR">
          <div class="location_column1">
            <div *ngFor="let srow of ml.cdata">
              <h4>{{srow?.state}}</h4>
              <ul>
                <li *ngFor="let lrow of srow.locations"><a
                    [routerLink]="[lang.LocationDetailsUrl, lrow.locationID]">{{lrow.listText}} <i
                      class="fa-solid fa-arrow-right"></i></a></li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="tab-pane fade" role="tabpanel" [ngClass]="{'show active':locationToggle.autoRecycling}" tabindex="0">
        <ng-template ngFor let-ml let-i="index" [ngForOf]="grpAR">
          <div class="location_column1">
            <div *ngFor="let srow of ml.cdata">
              <h4>{{srow?.state}}</h4>
              <ul>
                <li *ngFor="let lrow of srow.locations"><a
                    [routerLink]="[lang.LocationDetailsUrl, lrow.locationID]">{{lrow.listText}} <i
                      class="fa-solid fa-arrow-right"></i></a></li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="tab-pane fade"  role="tabpanel" [ngClass]="{'show active':locationToggle.steelManufacturing}"
        tabindex="0">
        <ng-template ngFor let-ml let-i="index" [ngForOf]="grpCSS">
          <div class="location_column1">
            <div *ngFor="let srow of ml.cdata">
              <h4>{{srow?.state}}</h4>
              <ul>
                <li *ngFor="let lrow of srow.locations"><a
                    [routerLink]="[lang.LocationDetailsUrl, lrow.locationID]">{{lrow.listText}} <i
                      class="fa-solid fa-arrow-right"></i></a></li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</section>
